<template>
    <div v-show="show" id="ms-preload" class="ms-preload" data-test-id="loading">
        <div id="status">
            <div class="spinner">
                <div class="dot1" />
                <div class="dot2" />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        show: {
            type: Boolean,
            required: true,
        },
    },
    // A `data` property is needed so that this file is taken into account by jest's code coverage
    // (cf. https://github.com/vuejs/vue-jest/issues/32)
    //
    data() {
        return {};
    },
};
</script>

<style scoped></style>
